export const GoogleMapApiConfig = 'AIzaSyBaGaIw1UfwAe45FBqIHcLP0v5DkxgBFcY';